import { render, staticRenderFns } from "./cfluckydrawuser.vue?vue&type=template&id=24fb72d4&scoped=true"
import script from "./cfluckydrawuser.vue?vue&type=script&lang=js"
export * from "./cfluckydrawuser.vue?vue&type=script&lang=js"
import style0 from "./cfluckydrawuser.vue?vue&type=style&index=0&id=24fb72d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb72d4",
  null
  
)

export default component.exports